import React, { Component } from "react";

import css from "./Video.css";
import { Button, Switch, message, Modal } from "antd";
import NHFetch from '../../../utils/NHFetch';
import { hasAuth } from "../../../utils/NHCore";
import { NHConfirm } from '../../common/NHModal';
import NHTable from '../../common/NHTable';

import VideoModal from "./VideoModal";

export default class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false, //增加视频和编辑视频对话框
      showDeleteBtn: false,
      formData: {}, //传给子组件的值
      frameVisibleMap: {
        addFlag: false,
        updateFlag: false,
        tableFlag: true,
        Classify: false,
      },
    };
  }
  //关闭内嵌页面
  handleCloseFrame = () => {
    this.setCurrentPageShow("tableFlag");
    this.refs.nhTable.filterTableData();
  };

  //设置当前页面显示
  setCurrentPageShow = (showFlagName) => {
    let frameVisibleMap = this.state.frameVisibleMap;
    for (let name in frameVisibleMap) {
      if (name === showFlagName) {
        frameVisibleMap[name] = true;
      } else {
        frameVisibleMap[name] = false;
      }
    }
    this.setState({
      frameVisibleMap: frameVisibleMap,
    });
  };
  // 增加按钮点击事件
  handleAddBtn = () => {
    this.setState({ modalVisible: true, formData: {} });
  };
  // 对话框关闭事件
  handleCancel = () => {
    this.setState({ modalVisible: false });
    this.refs.nhTable.filterTableData();
  };
  //处理修改视频信息
  handleUpdateBtnClick = (record) => {
    //处理修改操作

    let pkid = record.PKID;
    NHFetch(`/fwwgl/video/get/${pkid}`, "GET")
      .then((res) => {
        if (res && res.code == 200) {
          this.setState({ formData: res.data, modalVisible: true });
        }
      })
      .catch((err) => {});
  };
  //处理删除图片
  handleSingleDeleteBtnClick = (record) => {
    let pkids = [];
    pkids.push(record.PKID);
    console.log(pkids);
    NHConfirm(
      "是否删除该数据",
      () => {
        this.handleDelete(pkids);
      },
      "warn"
    );
  };
  //上升
  handleUp = (record) => {
    NHFetch("/fwwgl/video/videoUp/" + record.PKID, "GET")
      .then((res) => {
        if (res) {
          message.success("上升成功");
          this.refs.nhTable.filterTableData();
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  //下降
  handleDown = (record) => {
    NHFetch("/fwwgl/video/videoDown/" + record.PKID, "GET")
      .then((res) => {
        if (res) {
          message.success("下降成功");
          this.refs.nhTable.filterTableData();
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  handleToFlPage = () => {
    this.setCurrentPageShow("Classify");
    // this.refs.nhTable.filterTableData();
  };
  //启用禁用
  onClick = (pkid) => {
    this.setState({ loading: true });
    let nhTable = this.refs.nhTable;
    NHFetch("/fwwgl/video/updateZT/" + pkid, "GET")
      .then((res) => {
        if (res && res.code === 200) {
          nhTable.filterTableData();
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  //下拉款选中
  handleRowkey = (selectedRowKeys) => {
    if (selectedRowKeys.length <= 0) {
      this.setState({
        showDeleteBtn: false,
      });
    } else {
      this.setState({
        showDeleteBtn: true,
      });
    }
  };
  //多行删除
  handleMultiDeleteBtnClick = () => {
    let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      NHConfirm(
        "是否确定删除选中的多条数据？",
        () => {
          this.handleDelete(selectedRowKeys);
        },
        "warn"
      );
    } else {
      message.warning("请先选择需要删除的数据！");
    }
  };
  //删除操作
  handleDelete = (pkids) => {
    NHFetch("/fwwgl/video/deleteByMulti", "POST", pkids)
      .then((res) => {
        if (res) {
          message.success("删除成功！");
          this.refs.nhTable.filterTableData();
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { tableFlag, Classify } = this.state.frameVisibleMap;
    const { modalVisible, showDeleteBtn, formData } = this.state;

    const columns = [
      {
        title: "视频封面图",
        width: "200px",
        dataIndex: "SLT",
        commonSearch: false,
        render: (text, record) => {
          let path = "zuul/docrepo/download/file?attachmentId=" + record.SLT;
          return (
            <div>
              <img style={{ height: 83, width: 86 }} src={path} />
            </div>
          );
        },
      },
      {
        title: "上传时间",
        width: "182px",
        dataIndex: "CJSJ",
      },
      {
        title: "视频标题",
        width: "182px",
        dataIndex: "SPMC",
      },
      {
        title: "视频说明",
        width: "182px",
        dataIndex: "SPSM",
      },
      {
        title: "状态",
        width: "182px",
        dataIndex: "QYZT",
        render: (text, record) => {
          // const dataSource = [{ "VALUE": "1", "LABEL": "启用" }, { "VALUE": "0", "LABEL": "禁用" }]
          const status = record.QYZT === "启用";
          return (
            hasAuth("ly-sm-yxxt-svc_fwwgl_myVideo_zt") && (
              <Switch
                checkedChildren="启用"
                unCheckedChildren="禁用"
                checked={status}
                onClick={() => this.onClick(record.PKID)}
              />
            )
          );
        },
      },
    ];
    // console.log(record.PKID)
    const action = [
      {
        title: "修改",
        onClick: this.handleUpdateBtnClick,
        auth: "ly-sm-yxxt-svc_fwwgl_myVideo_update",
      },
      {
        title: "删除",
        onClick: this.handleSingleDeleteBtnClick,
        auth: "ly-sm-yxxt-svc_fwwgl_myVideo_delete",
      },
      {
        title: "上升",
        onClick: this.handleUp,
        auth: "ly-sm-yxxt-svc_fwwgl_myVideo_up",
      },
      {
        title: "下降",
        onClick: this.handleDown,
        auth: "ly-sm-yxxt-svc_fwwgl_myVideo_down",
      },
    ];

    return (
      <div className={css.main_right_content}>
       
        <div
          className={css.table}
          style={{ display: tableFlag ? "block" : "none" }}
        >
          <NHTable
            ref="nhTable"
            rowKey={(record) => record.PKID}
            sign={"zhxg_yxxt_fwwgl_spgl"}
            columns={columns}
            action={action}
            rowSelectionChange={this.handleRowkey}
            // rowSelectionChange={this.rowSelectionChange}
            rangeFilter={false}
            checkbox={true}
          >
            {hasAuth("ly-sm-yxxt-svc_fwwgl_myVideo_add") && (
              <Button
                type="primary"
                onClick={this.handleAddBtn}
                style={{ marginRight: "15px" }}
              >
                新增
              </Button>
            )}
            {hasAuth("ly-sm-yxxt-svc_fwwgl_myVideo_delete") && (
              <Button
                type="danger"
                style={{ display: showDeleteBtn ? "inline-block" : "none" }}
                onClick={this.handleMultiDeleteBtnClick}
              >
                删除
              </Button>
            )}
          </NHTable>
          {/* 添加视频 */}
          <Modal
            title="添加视频"
            visible={modalVisible}
            // onOk={this.handleOk}
            onCancel={this.handleCancel}
            width={"424px"}
            footer={null}
            destroyOnClose
            style={{ height: "590px" }}
          >
            <VideoModal
              ref={(ele) => (this.nhVideoModal = ele)}
              //   editData={formInitData}
              formData={formData}
              onCancel={this.handleCancel}
            />
          </Modal>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/fwwgl/spgl/Video.js